import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./About.module.css";

const About = () => {
    const { t } = useTranslation();

    return (
        <div className={styles.aboutContainer}>
            <div className={styles.titleSection}>
                <h1 className={styles.title}>AIDA</h1>
                <h2 className={styles.subtitle}>Artificial Intelligence for Development Analytics</h2>
                <p className={styles.tagline}>Trusted evidence from UNDP evaluations, powered by AI</p>
            </div>
            <div className={styles.aboutContent}>
                <section className={styles.section}>
                    <h2 className={styles.sectionTitle}>What is AIDA?</h2>
                    <p className={styles.sectionText}>
                        AIDA is an AI-powered chatbot that answers your questions with evidence from almost 7000 UNDP thematic, country-level and project
                        evaluation reports.
                    </p>
                    <p className={styles.sectionText}>
                        Ask questions in your language and receive translated insights from reports written in English, French, Spanish and more.
                    </p>
                    <p className={styles.sectionText}>AIDA is still being improved, and advanced features are on the way!</p>
                </section>

                <section className={styles.section}>
                    <h2 className={styles.sectionTitle}>What can AIDA do for me?</h2>
                    <p className={styles.sectionText}>AIDA helps you make better decisions with evidence from real-world evaluations.</p>
                    <ul className={styles.sectionText}>
                        <li>Find out what worked, what didn’t, and why—across countries, sectors, and timeframes.</li>
                        <li>Extract lessons and recommendations from similar projects to guide your next steps.</li>
                        <li>Use AIDA to support policy, planning, and implementation with grounded insights.</li>
                    </ul>
                </section>
            </div>
        </div>
    );
};

export default About;
